import { Form, SelectField, TextInputField } from "@sainsburys-tech/luna-form";
import { Container, GridItem, GridWrapper } from "@sainsburys-tech/luna-grid";
import React, { FC, useState, useEffect } from "react";
import "../../Edit-FamilyGroup/familyGroupModalEdit.scss";
import ActionButton from "../../../SharedComponents/ActionButton";
import { useSelector } from "react-redux";
import {
  FormInputLevels,
  ProductTypeOptions,
  MANAGEMENTFIELDS,
  SerialControlOptions,
} from "../../../../Interfaces/IFamilyGroupManagementFormField";
import FamilyGroupAutoComplete from "../../../SharedComponents/FamilyGroupAutoComplete";
import { FamilyGroupManagementProps } from "../../../../Types/familyGroupManagementFormProps";
import { CheckboxField } from "@sainsburys-tech/luna-form";

const FamilyGroupManagementForm: FC<FamilyGroupManagementProps> = (props) => {
  const payload = useSelector((state: any) => state.popupReducer);
  const isInitialState =
    JSON.stringify(payload?.data?.editPayload?.values) ===
    JSON.stringify(props.values);

  return (
    <Container>
      <Form className="o-form">
        <GridWrapper className="ln-u-push-bottom">
          <GridItem size={{ sm: "1/2" }}>
            <SelectField
              name={MANAGEMENTFIELDS.ProductType.name}
              label={FormInputLevels.ProductType}
              options={ProductTypeOptions}
              defaultValue={props.values.ProductType}
              error={props.errors?.ProductType}
              value={props.values.ProductType}
              onChange={props.onChange}
              onBlur={props.onBlur}
              placeholder=""
            />
          </GridItem>
          <GridItem size={{ sm: "1/2" }}>
            <h4 style={{ fontSize: "1.125rem" }}>Family Group</h4>
            <span className="familygroup-management-autocomplete">
              <FamilyGroupAutoComplete
                productType={props.values.ProductType}
                className="family-Group-AutoCompleteModal"
                name={MANAGEMENTFIELDS.FamilyGroup.name}
                testid="autocomplete-field"
                initialValue={
                  payload?.data?.editPayload?.values?.FamilyGroup || ""
                }
                onSelect={(e: any) => {
                  if (e?.target) {
                    props.onChange(e, "", "", false);
                  }
                }}
                error={props.errors?.FamilyGroup}
                disabled={props.isEdit ? true : false}
              />
            </span>
          </GridItem>
        </GridWrapper>
        <GridWrapper className="ln-u-push-bottom">
          <GridItem size={{ sm: "1/2" }}>
            <TextInputField
              name={MANAGEMENTFIELDS.FamilyGroupDescription.name}
              label={FormInputLevels.FamilyGroupDescription}
              value={props.values.FamilyGroupDescription}
              onChange={props.onChange}
              onBlur={props.onBlur}
              error={props.errors?.FamilyGroupDescription}
              disabled={props.isEdit}
            />
          </GridItem>
        </GridWrapper>
        <GridWrapper className="ln-u-push-bottom">
          <GridItem size={{ sm: "1/2" }}>
            <CheckboxField
              label={<p></p>}
              name={MANAGEMENTFIELDS.LPFamilyGroupMix.name}
              outlined
              options={[
                {
                  value: "LPFamilyGroupMix",
                  label: FormInputLevels.LPFamilyGroupMix,
                },
              ]}
              defaultChecked={
                payload?.data?.editPayload?.values.LPFamilyGroupMix
                  ? true
                  : false
              }
              onClick={(e: any) => {
                props.onChange(e, "", "", true);
              }}
              fullWidth
            />
          </GridItem>
          <GridItem size={{ sm: "1/2" }}>
            <CheckboxField
              label={<p></p>}
              name={MANAGEMENTFIELDS.MLPFamilyGroupMix.name}
              outlined
              options={[
                {
                  value: "MLPFamilyGroupMix",
                  label: FormInputLevels.MLPFamilyGroupMix,
                },
              ]}
              defaultChecked={
                payload?.data?.editPayload?.values.MLPFamilyGroupMix
                  ? true
                  : false
              }
              onClick={(e: any) => {
                props.onChange(e, "", "", true);
              }}
              fullWidth
            />
          </GridItem>
        </GridWrapper>
        <GridWrapper className="ln-u-push-bottom">
          <GridItem size={{ sm: "1/2" }}>
            <SelectField
              name={MANAGEMENTFIELDS.SerialControl.name}
              label={FormInputLevels.SerialControl}
              options={SerialControlOptions}
              defaultValue={props.values.SerialControl}
              value={props.values.SerialControl}
              onChange={props.onChange}
              onBlur={props.onBlur}
              placeholder={false}
            />
          </GridItem>
          <GridItem size={{ sm: "1/2" }}>
            <TextInputField
              name={MANAGEMENTFIELDS.SerialInputMask.name}
              label={FormInputLevels.SerialInputMask}
              value={props.values.SerialInputMask}
              onChange={props.onChange}
              onBlur={props.onBlur}
              error={props.errors?.SerialInputMask}
            />
          </GridItem>
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <CheckboxField
              label={<p></p>}
              name={MANAGEMENTFIELDS.StrapTotes.name}
              outlined
              options={[
                {
                  value: "StrapTotes",
                  label: FormInputLevels.StrapTotes,
                },
              ]}
                defaultChecked={
                  payload?.data?.editPayload?.values.StrapTotes
                }
              onClick={(e: any) => {
                props.onChange(e, "", "", true);
              }}
              fullWidth
            />
          </GridItem>
        </GridWrapper>
        <GridWrapper className="ln-u-push-bottom">
          {props.isEdit && (
            <GridItem size={{ sm: "1/2" }}>
              <TextInputField
                data-testid="input-CreatedDate"
                name={MANAGEMENTFIELDS.CreatedDate.name}
                label={FormInputLevels.createdDate}
                maxLength={128}
                value={props.values.CreatedDate}
                error={props.errors?.CreatedDate}
                disabled={true}
                required
              />
            </GridItem>
          )}

          {props.isEdit && (
            <GridItem size={{ sm: "1/2" }}>
              <TextInputField
                data-testid="input-UpdatedDate"
                name={MANAGEMENTFIELDS.UpdatedDate.name}
                label={FormInputLevels.updatedDate}
                maxLength={128}
                value={
                  props.values.UpdatedDate === "Invalid date"
                    ? "N/A"
                    : props.values.UpdatedDate
                }
                error={props.errors?.UpdatedDate}
                disabled={true}
                required
              />
            </GridItem>
          )}
        </GridWrapper>
      </Form>
      
      <ActionButton
        onSubmit={props.onSubmit}
        onClearAll={props.onClearAll}
        onCancel={props.onCancel}
        isAddDisabled={isInitialState}
        isDirty={props.dirty}
        isEdit={props.isEdit}
        isClearButtonRequired={false}
        submitted={props.submitted}
      />
    </Container>
  );
};

export default FamilyGroupManagementForm;
